import React from 'react'
import * as PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { useGoogleLogin } from '@react-oauth/google'

import FBErrorModal from '../LoginForm/FBErrorModal'
import RegisterModal from '../LoginForm/RegisterModal'
import Icon from '../../../../components/ui/Icon/Icon'
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'

import validateLogin from '../../../../services/validation/Login'
import { postDevices } from '../../../../services/api/requests/Device'
import {
  setGACustomEvent,
  setGACustomPageView,
} from '../../../../services/analytics/google-analytics'

// simplified login components
import LoginForm from '../LoginForm/LoginForm'
import { Layout as MainLayout } from '../../../../components/ui/SimplifiedLogin'
import {
  Title,
  Divider,
  StyledLink,
  Description,
  FormWrapper,
  SocialButton,
  LinkDescription,
  ContentContainer,
  SocialButtonLabel,
  SocialButtonWrapper,
  AlternateLoginPrompt,
} from './MainView.style'
import { REGISTRATION_STEPS } from '../../../../services/hooks/useRegistrationBanners'

function MainView(props) {
  const {
    history,
    browser,
    replace,
    firebase,
    location = {},
    setStep,
    setLoginStep,
    setDevice,
    setPrimaryInfo,
    setLoyaltyPoints,
    setAccessToken,
    saveAccessToken,
    setAppleToken,
    setGoogleToken,
    doGetFirebaseToken,
    redirectAfterAuth,
    firebaseMessagingToken,
    setFirebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    doLogin,
    doAppleLogin,
    doGoogleLogin,
    setLoginRequestId,
    setAuthRequestData,
  } = props
  const [performingSocialAuth, setPerformingSocialAuth] = React.useState(false)
  const [registerNumber, setRegisterNumber] = React.useState(false)
  const [FBErrorModalProps, setFBErrorModalProps] = React.useState({
    show: false,
  })

  const redirectToThirdParty = async (redirectUri, code) => {
    if (typeof window !== undefined && window.location && redirectUri) {
      window.location.href = redirectUri + (code ? `?code=${code}` : '')
    }
  }
  const signInWithApple = () => {
    setGACustomEvent('button_cta', {
      screen_name: 'Login',
      button_name: 'Continue with Apple',
    })

    window.AppleID.auth.signIn()
  }
  const handleAppleLogin = response => {
    doAppleLogin({
      setPrimaryInfo,
      setLoyaltyPoints,
      replace,
      setStep,
      saveAccessToken,
      setAccessToken,
      setAppleToken,
      redirectAfterAuth,
      firebaseMessagingToken,
      doSubscribeToFirebaseMessaging,
      setPerformingSocialAuth,
      redirectToThirdParty,
      searchString: location.search,
    })(response)
  }
  const googleLogin = useGoogleLogin({
    onSuccess: doGoogleLogin({
      setPrimaryInfo,
      setLoyaltyPoints,
      replace,
      setStep,
      saveAccessToken,
      setAccessToken,
      setGoogleToken,
      redirectAfterAuth,
      firebaseMessagingToken,
      doSubscribeToFirebaseMessaging,
      setPerformingSocialAuth,
      redirectToThirdParty,
      searchString: location.search,
    }),
    onFailure: () => {
      setPerformingSocialAuth(false)
    },
  })
  const handleGoogleLogin = () => {
    setGACustomEvent('button_cta', {
      screen_name: 'Login',
      button_name: 'Continue with Google',
    })

    setPerformingSocialAuth(true)
    googleLogin()
  }
  // ST-4668 - block FB TPA logins
  // const handleBlockFBLogin = () => {
  //   setFBErrorModalProps({
  //     show: true,
  //     title: 'Please login using your registered mobile number.',
  //     description: 'Facebook login will no longer be available.',
  //   })
  // }
  const onClickHelpCenter = e => {
    e.preventDefault()
    setGACustomEvent('button_cta', {
      screen_name: 'Login',
      button_name: 'Visit our Help Center',
    })
    const faq = window.open('/main/faq', '_blank')
    faq.addEventListener('load', () => {
      const selectedFAQ = {
        type: 'selectedFAQ',
        category: { key: 'name', value: 'General' },
        item: {
          key: 'question',
          value: "What if I can't login?",
        },
      }
      faq.postMessage(selectedFAQ)
    })
  }

  const handleModalConfirm = () => {
    setGACustomEvent('button_cta', {
      screen_name: 'Registration - Native Registration Popup',
      button_name: 'Register',
    })
    history.push({
      pathname: `/register`,
      search: location.search,
      state: { username: registerNumber },
    })
  }
  const handleModalCancel = () => {
    setRegisterNumber(false)
    setGACustomEvent('button_cta', {
      screen_name: 'Registration - Native Registration Popup',
      button_name: 'Not Now',
    })
  }

  React.useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
    script.async = true

    document.body.appendChild(script)
    script.onload = () => {
      window.AppleID.auth.init({
        clientId: process.env.REACT_APP_SIWA_CLIENT_ID,
        scope: 'name email',
        redirectURI: process.env.REACT_APP_SIWA_REDIRECT_URI,
        state: 'apple',
        response_type: 'id_token',
        response_mode: 'form_post',
        usePopup: true, //or false defaults to false
      })

      document.addEventListener('AppleIDSignInOnSuccess', data => {
        let value = data.detail
        // console.debug('========= Success =========')
        // console.debug(data)
        // console.debug(value)
        // console.debug('===========================')
        handleAppleLogin(value)
      })

      //Listen for authorization failures
      document.addEventListener('AppleIDSignInOnFailure', error => {
        // let value = JSON.stringify(error.detail)
        // console.debug('========== Error ==========')
        // console.debug(error)
        // console.debug(value)
        // console.debug('===========================')
      })
    }

    return () => {
      document.body.removeChild(script)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  React.useEffect(() => {
    setGACustomPageView({ page: location.pathname, title: 'Login' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])
  React.useEffect(() => {
    doGetFirebaseToken({
      firebase,
      setFirebaseMessagingToken,
    })
  }, [doGetFirebaseToken, firebase, setFirebaseMessagingToken])
  React.useEffect(() => {
    if (window.document.cookie.includes('web_uuid=')) {
      return
    }
    const { name, os, version } = browser
    postDevices({
      platform: 'web',
      deviceName: name,
      deviceModel: os,
      osVersion: version,
    }).then(res => {
      setDevice(res.data)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <MainLayout registrationStep={REGISTRATION_STEPS.LOGIN} showVersion>
      <ContentContainer minHeight={620}>
        <div>
          <Title>Welcome!!</Title>
          <Description>
            Get ready for something amazing. Exclusive perks and benefits are
            yours in just a few clicks.
          </Description>
          <FormWrapper>
            <AccessibleForm
              enableReinitialize
              disabled={performingSocialAuth}
              initialValues={{ username: '' }}
              onSubmit={doLogin({
                replace,
                setLoginStep,
                setLoginRequestId,
                setAuthRequestData,
                redirectToThirdParty,
                searchString: location.search,
                setRegisterNumber: setRegisterNumber,
              })}
              method="post"
              action="/a/login"
              validate={validateLogin}
              render={props => <LoginForm {...props} />}
            />
          </FormWrapper>
        </div>
        <SocialButtonWrapper>
          <AlternateLoginPrompt>
            <Divider />
            <b>OR</b>
            <Divider />
          </AlternateLoginPrompt>
          <SocialButton color="#000000" onClick={signInWithApple}>
            <Icon name="apple" />
            <SocialButtonLabel>Continue with Apple</SocialButtonLabel>
          </SocialButton>
          {/* 

          ST-6869 - Login :: TPA : Remove Facebook Login

          <SocialButton color="#1877F2" onClick={handleBlockFBLogin}>
            <Icon name="facebook" />
            <SocialButtonLabel>Continue with Facebook</SocialButtonLabel>
          </SocialButton>
          
           */}
          <SocialButton color="#F14336" onClick={handleGoogleLogin}>
            <Icon name="google" />
            <SocialButtonLabel>Continue with Google</SocialButtonLabel>
          </SocialButton>
        </SocialButtonWrapper>
        <LinkDescription>
          Having problems?&nbsp;
          <StyledLink to="#" onClick={onClickHelpCenter}>
            Visit our Help Center
          </StyledLink>
        </LinkDescription>
        <div />
      </ContentContainer>
      <RegisterModal
        show={!!registerNumber}
        onConfirmClick={handleModalConfirm}
        onCancelClick={handleModalCancel}
      />
      <FBErrorModal
        {...FBErrorModalProps}
        onCancelClick={() => setFBErrorModalProps({ show: false })}
      />
    </MainLayout>
  )
}

MainView.defaultProps = {
  redirectAfterAuth: '',
  firebaseMessagingToken: '',
}

MainView.propTypes = {
  location: PropTypes.shape(),
  setPrimaryInfo: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  redirectAfterAuth: PropTypes.string,
  saveAccessToken: PropTypes.func.isRequired,
  setAccessToken: PropTypes.func.isRequired,
  setGoogleToken: PropTypes.func.isRequired,
  setAppleToken: PropTypes.func.isRequired,
  firebaseMessagingToken: PropTypes.string,
  replace: PropTypes.func.isRequired,
  firebase: PropTypes.shape(),
  setFirebaseMessagingToken: PropTypes.func.isRequired,
  doGetFirebaseToken: PropTypes.func.isRequired,
  doLogin: PropTypes.func.isRequired,
  doGoogleLogin: PropTypes.func.isRequired,
  doAppleLogin: PropTypes.func.isRequired,
  doSubscribeToFirebaseMessaging: PropTypes.func.isRequired,
}

export default withRouter(MainView)
